import myImage from "../assets/Rectangle 26.jpg";
import { mail } from "../projectConfig";
import About from "./sections/About";
import Contact from "./sections/Contact";
import Projects from "./sections/Projects";
import { useIntersectionObserver } from "./sections/components/observer";

export default function Homepage() {
  const observer = useIntersectionObserver();

  return (
    <main>
      <section
        className="pt-[25%] lg:pt-[10%] min-h-[65vh] flex items-center"
        id="home"
        ref={(el) => observer(el)}
      >
        <div>
          <div className="grid justify-center items-center md:grid-flow-col md:grid-cols-2 lg:gap-[10%]">
            <div className="">
              <h1 className="text-primary-10 text-xl lg:text-[50px] font-bold">
                Welcome!
              </h1>
              <p className="mt-4 md:mt-6 mb-2 md:mb-4 text-base md:text-xl">
                Hi there,
              </p>
              <h1 className="text-2xl md:text-4xl">
                I’m{" "}
                <span className="text-secondary text-3xl md:text-5xl">
                  &#123;
                </span>
                <span className="text-primary-10 text-3xl md:text-5xl">
                  Ephraim Udazi
                </span>
                <span className="text-secondary text-3xl md:text-5xl">
                  &#125;
                </span>
                , <br /> a Frontend Fullstack Software Engineer
              </h1>
              <p className="mt-1 md:mt-6 text-black/70 dark:text-white/70 pr-5">
                I bring the <span className="text-secondary">&lt;</span>
                <span className="text-primary-10">web</span>
                <span className="text-secondary">/&gt;</span> closer to your
                place of comfort.
              </p>

              <div className="btn-hover">
                <a href={mail} target="_blank" rel="noreferrer">
                  <button className="my-4 btnC">
                    <span className="span1"></span>
                    <span className="span2"></span>
                    Contact me
                  </button>
                </a>
              </div>
            </div>
            <div className="my-4">
              <img className="" src={myImage} alt="myimage" />
            </div>
          </div>
          <div>
            <p className="text-center w-100 text-black/70 dark:text-white/70 text-lg md:text-xl mt-3 md:mt-8">
              "For what it's worth, I declare{" "}
              <span className="text-secondary">&lt;</span>
              <span className="text-primary-10">Variables</span>
              <span className="text-secondary">/&gt;</span>, not War"
            </p>
          </div>
        </div>
      </section>
      <section id="about" ref={(el) => observer(el)} className="min-h-screen">
        <About />
      </section>
      <section
        id="projects"
        ref={(el) => observer(el)}
        className="min-h-screen"
      >
        <Projects />
      </section>
      <section id="contact" ref={(el) => observer(el)} className="min-h-screen">
        <Contact />
      </section>
    </main>
  );
}
